import React, {CSSProperties} from 'react';
import './GroupTitle.css'

const classNames = require('classnames');

export function GroupTitleBackground(props: { children?: string }) {
    return (
        <p className='group-title-bg'>
            {props.children ? props.children.toLocaleUpperCase() : ""}
        </p>
    )
}

export function GroupTitleText(props: {
    children: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <p className='group-title-text'>
            {props.children}
        </p>
    )
}

export function GroupTitleColor(props: {
    children?: JSX.Element | Array<JSX.Element> | string
    color?: string
}) {
    return (
        <span style={{color: props.color}}>
            {props.children}
        </span>
    )
}

export function GroupTitileOrange(props: {
    children?: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <GroupTitleColor color="#f19149">
            {props.children}
        </GroupTitleColor>
    )
}

export default function GroupTitle(props: {
    children?: JSX.Element | Array<JSX.Element> | string
    className?: string
    style?: CSSProperties
}) {

    return (
        <div className={classNames('group-title', props.className)} style={{}}>
            {props.children}
        </div>
    )
}